import type { ChatRole } from '../types';

interface RoomWithId {
  room_id: string;
}

export const roomMatchesViewerRole = (
  room: RoomWithId,
  _currentUserId: number,
  _viewerRole: ChatRole,
): boolean => {
  const parts = room.room_id?.split(':') ?? [];
  // Только канонические чаты по отклику; legacy chat:tutor:student не показываем.
  return parts.length === 3 && parts[0] === 'chat' && parts[1] === 'br' && /^\d+$/.test(parts[2]);
};
